<template>
    <div class="step-box">
        <div class="step-head">第一步 选择投稿作品</div>
        <div class="step-body">
            <div class="section-tip">
                <p>1、每一位参赛选手只投递一个作品。</p>
                <p>2、请投递{{limitStartTime}}后发布的原创非改编作品。</p>
                <p>3、已投递作品在评审前仍可编辑更新，无需多次投递。</p>
            </div>
            <ul class="work-list" v-if="works.length">
                <li v-for="(item, index) in works" :key="index">
                    <div class="work" @click='check(item, index)' :class="{'checked': item.checked === true}">
                        <img class="poster" :src="item.coverUrl">
                        <div class="title">{{ item.title }}</div>
                        <div class="check" v-if="item.ableDelivery"></div>
                    </div>
                    <div class="status" v-if="!item.ableDelivery">该作品不符合参赛资格</div>
                </li>
            </ul>
            <div class="no-data" v-else>
                当前作品为空，请返回比赛介绍页，查阅“参赛指引”并根据提示发布作品哟~
            </div>
            <div class="op-box">
                <a href="javascript:" class="btn primary" :class="{'disabled': !pList.length}"
                   @click="chooseWork">下一步</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "work",
        props: {
            works: Array,
            projectList: Array,
            userInfo: Object,
            limitStartTime: String,
        },
        data() {
            return {
                pList: [],
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                if (this.projectList.length) {
                    this.pList = [].concat(this.projectList)
                    this.works.forEach((work, index) => {
                        if (work.projectId === this.pList[0]) {
                            this.$set(this.works, index, Object.assign(work, {checked: true}))
                        }
                    })
                }
            },
            check(item, checkIndex) {
                if (!item.ableDelivery)
                    return
                this.works.forEach((work, index) => {
                    let newWork, checked
                    if (index === checkIndex) {
                        if (work.projectId === this.pList[0]) {
                            checked = false
                            this.pList = []
                        } else {
                            checked = true
                            this.pList = [work.projectId]
                        }
                    } else {
                        checked = false
                    }
                    newWork = Object.assign(work, {checked})
                    this.$set(this.works, index, newWork)
                })
            },
            chooseWork() {
                if (!this.pList.length)
                    return
                this.$emit('getChooseWork', this.pList)
            }
        }
    }
</script>

<style lang="scss" scoped>
    ul.work-list {
        padding-top: 30px;
        height: 980px;
        overflow-y: auto;
        margin-bottom: 20px;

        li {
            width: 283px;
            float: left;
            margin: 0 47px 45px 0;
            position: relative;

            &:nth-child(3n) {
                margin-right: 0;
            }

            .status {
                position: absolute;
                width: 100%;
                height: 34px;
                bottom: -34px;
                line-height: 34px;
                text-align: center;
                font-size: 15px;
                color: #0546a8;
            }
        }

        .work {
            background: rgba(2, 27, 63, .7);
            padding: 8px 0;
            border-radius: 10px;
            text-align: center;
            cursor: pointer;

            .poster {
                width: 271px;
                height: 204px;
                border-radius: 10px;
                margin-bottom: 8px;
            }

            .title {
                width: 271px;
                height: 24px;
                line-height: 24px;
                font-size: 16px;
                color: #fff;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin: 0 auto 5px;
                text-align: left;
            }

            .check {
                position: absolute;
                width: 30px;
                height: 30px;
                right: 10px;
                top: 15px;
                background: url('../../assets/images/check.png') no-repeat center;
            }

            &.checked {
                .check {
                    background: url('../../assets/images/check-cur.png') no-repeat center;
                }
            }
        }
    }
    .no-data {
        text-align: center;
        font-size: 16px;
        margin-bottom: 50px;
    }

</style>
